import { atom } from "recoil";

export const events = atom({
  key: "events",
  default: true,
});
